module.exports = __webpack_public_path__ + "img/client4.41ad52f9.png";